import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {CryptoService} from './crypto.service';

@Injectable({
  providedIn: 'root'
})
export class FirmWareService {

  constructor(private http: HttpClient, private cryptoService: CryptoService) { }

  // 由後端 (config.json) 判斷 email 是否為 firmware admin，前端不持有名單。
  CheckFirmwareAdmin(email: string): Observable<boolean> {
    if (!email) {
      return of(false);
    }
    const lower = email.toLowerCase();
    return this.http.post<{isFirmwareAdmin: boolean}>(`/api/auth/firmware-admin/check`, { email: lower }).pipe(
      map(res => !!(res && res.isFirmwareAdmin)),
      catchError(() => of(false))
    );
  }

  ReadFirmware(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/firmware/read`, params);
  }

  ReadFirmwareLog(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/firmware/log/read`, params);
  }

  UpgradeFirmware(params): Observable<any> {
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/firmware/upgrade`, params);
  }

  AddFirmwareInfo(params): Observable<any> {
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/firmware/info/add`, params);
  }

  UpdateFirmwareInfo(params): Observable<any> {
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/firmware/info/update`, params);
  }

  ReleaseFirmwareInfo(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/firmware/info/release`, params);
  }

  ReadFirmwareInfo(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/firmware/info/read`, params);
  }

  ReadFirmwareInfoList(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/firmware/info/list`, params);
  }

  ReadFirmwareMgtLog(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/firmware/mgt/log`, params);
  }
}
